import angular from 'angular';

import progressBarComponent from './abu-progress-bar-component';

const abuProgressBar = angular.module('abuProgressBar', []);

abuProgressBar.component('abuProgressBar', progressBarComponent);

export default abuProgressBar.name;
